import { flowRight, get } from 'lodash';
import {
  getLayoutName,
  POST_LIST_COMPONENT_MASONRY,
  SEO_LAYOUT_TYPE_FALLBACK,
  type MobileLayoutType,
  type LayoutType,
  type Section,
} from '@wix/communities-blog-client-common';
import { connect } from '../components/runtime-context';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type useLayoutProps from '../hooks/use-layout-props';
import {
  getLayoutType,
  isMasonryLayoutSupported,
} from '../selectors/layout-selectors';
import { getSection } from '../selectors/section-selectors';
import { getLayoutConfig } from '../services/layout-config';
import { type AppState } from '../types';
import withHocName from './with-hoc-name';

export type WithLayoutOwnProps = {
  section?: Section;
  layoutType?: LayoutType;
  mobileLayoutType?: MobileLayoutType;
};

export type WithLayoutProps = ReturnType<ReturnType<typeof mapRuntimeToProps>>;

const mapRuntimeToProps =
  (fallbackEnabled: boolean) =>
  (state: AppState, ownProps: WithLayoutOwnProps) => {
    const section = ownProps.section || getSection(state, fallbackEnabled);
    const mobileLayoutType =
      ownProps.mobileLayoutType || getLayoutType(state, section, true);
    let layoutType = ownProps.layoutType || getLayoutType(state, section);

    if (
      !isMasonryLayoutSupported(state) &&
      layoutType &&
      getLayoutConfig(layoutType)?.listComponentName ===
        POST_LIST_COMPONENT_MASONRY
    ) {
      layoutType = SEO_LAYOUT_TYPE_FALLBACK;
    }

    return {
      section,
      layoutType,
      mobileLayoutType,
      layoutName: getLayoutName(layoutType as LayoutType),
      mobileLayoutName: getLayoutName(mobileLayoutType as MobileLayoutType),
    };
  };

/** @deprecated Use {@link useLayoutProps} hook instead */
export default function withLayoutProps({ fallbackEnabled = true } = {}) {
  return flowRight(
    connect(mapRuntimeToProps(fallbackEnabled)),
    withHocName('WithLayoutProps'),
  );
}
